import React, { useEffect } from "react";
import { useQuickAdd } from "@foundation/quickadd-provider";

import ErrorBoundary from "~components/shared/errorBoundary";

import TickerPill from "../ticker-pill/TickerPill";

import styles from "./TickerPills.module.css";

export interface TickerPillsProps {
    tickerIds?: string[];
    storyIndex?: number;
}

export const MAX_TICKERS = 2;

export default function TickerPills({
    tickerIds,
    storyIndex,
}: TickerPillsProps) {
    const { controller: qac } = useQuickAdd();

    useEffect(() => {
        if (!qac || !tickerIds?.length) {
            return;
        }

        tickerIds.forEach((ticker) => {
            qac.registerTicker(ticker);
        });

        qac.updateTickerWatchlists();
    }, [tickerIds, qac]);

    if (!tickerIds?.length) {
        return null;
    }

    return (
        <div data-component="ticker-pills" className={styles.TickerPills}>
            {tickerIds.slice(0, MAX_TICKERS).map((tickerId, index) => (
                <ErrorBoundary key={tickerId}>
                    <TickerPill
                        storyIndex={storyIndex}
                        relatedIndex={index + 1}
                        key={tickerId}
                        className={styles.pill}
                        tickerId={tickerId}
                    />
                </ErrorBoundary>
            ))}
        </div>
    );
}
